import React from "react";
import { capitalizeName, formatDateForQuery } from "../utils/utils";
import DynamicTable from "./ui/DynamicTable";
import Pagination from "./ui/Pagination";
import { FaEye } from "react-icons/fa";

const QueryList = ({ queries, onView, pagination, onPageChange }) => {
  const renderView = (_, row) => {
    return <span className="view-icon" onClick={() => { onView(row.query_id, row.status);}}><FaEye /></span>
  };

  const renderStatus = (value, _) => {
    return <span className={`status-tile ${value === "open" ? "open" : "closed"}`}>{value.toUpperCase()}</span>
  }

  const renderCapitalized = (value, _) => {
    return value ? capitalizeName(value) : "N/A";
  }

  const renderDateInFormat = (value, _) => {
    return value ? formatDateForQuery(value) : "N/A";
  }

  const columns = [
    { key: "query_id", label: "Query ID" },
    { key: "subject", label: "Subject" },
    { key: "created_by_name", label: "Opened By", render: renderCapitalized },
    { key: "closed_by_name", label: "Closed By", render: renderCapitalized },
    { key: "closed_at", label: "Closed At", render: renderDateInFormat },
     { key: "status", label: "Status", render: renderStatus },
    { key: "view", label: "View", render: renderView },
  ]

  return (
    queries.length === 0 ? (
      <p>No queries created yet.</p>
    ) : (
      <>
        <DynamicTable data={queries} columns={columns} />
        <Pagination totalPages={pagination.total_pages} page={pagination.current_page} handlePageChange={onPageChange}/>
      </>
    )
  );
}

export default QueryList;
